import * as yup from 'yup'
import i18n from '@/localization/i18n'
import constants from '@/utils/constants'
import { isLocalhost } from '@/utils/functions'

const t = i18n.global.t
const isCaptchaRequired = !isLocalhost()

export const schemaValidatorLogin = (isFinal: boolean = true) => {
    return yup.object().shape({
        email: isFinal ? yup.string().matches(constants.EMAIL_REGEX, t('w_msg_frmVal_emailFormat'))
            .required(t('w_msg_frmVal_required')) : yup.string()
                .required(t('w_msg_frmVal_required')),
        password: yup.string().required(t('w_msg_frmVal_requiredPassword')),
        cloud_flare_token: isCaptchaRequired
            ? yup.string().required(t('w_msg_frmVal_requiredCaptcha'))
            : yup.string().notRequired(),
    })
}

export const businessRequestLoginSchema = schemaValidatorLogin()
